export default function (qty: number) {
  return qty > 10 ? qty : 10
}
